import { observable, computed, action, runInAction } from "mobx";
import { IUser, IUserFormValues } from "../models/user";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { history } from "../..";
import Swal from 'sweetalert2';
export default class UserStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable user: IUser | null = null;

  @computed get isLoggedIn() {
    return !!this.user;
  }

  @action login = async (values: IUserFormValues) => {
    try {
      const user = await agent.User.login(values);
      if (user.code === -1) {
        runInAction(() => {
          this.user = null;
          throw Error;
        });
      } else {
        runInAction(() => {
          this.user = user;
        });
        this.rootStore.commonStore.setUsername(values.email);
        this.rootStore.commonStore.setToken(user.token);
        this.rootStore.modalStore.closeModal();
        history.push("/warranties");
      }
    } catch (error) {
      throw error;
    }
  };

  @action logout = () => {
    this.rootStore.commonStore.setToken(null);
    this.rootStore.commonStore.setUsername(null);
    this.user = null;
    history.push("/");

    Swal.fire({
      icon: 'success',
      title: 'Logout Successful',
      showCancelButton: false,
      showConfirmButton: false,
      timer: 1000
        
    })
  };
}
